'use strict'

angular
  .module('basalteApp')
  .constant('PAGE_PROTECTION', {
    PREFIX_PAGE: 'page:',
    P_DOORS: 'doors',
    P_SCENES: 'scenes',
    P_SETTINGS: 'settings'
  })
